<div class="data container-fluid ps-1 pe-0">
	<div class="address-container">
		<div class="row">
			<div class="col-md-4">Address</div>
			<div class="col-md-8">{{address}}</div>
		</div>
		<div class="row">
			<div class="col-md-4">City</div>
			<div class="col-md-8">{{publicRecord.city}}</div>
		</div>
		<div class="row">
			<div class="col-md-4">County</div>
			<div class="col-md-8">{{publicRecord.county}}</div>
		</div>
		<div class="row">
			<div class="col-md-4">State</div>
			<div class="col-md-8">{{publicRecord.state}}</div>
		</div>
		<div class="row">
			<div class="col-md-4">Zip</div>
			<div class="col-md-8">{{publicRecord.postalCode}}</div>
		</div>
	</div>

	<div class="row">
		<div class="col separator">
			<span class="title text-capitalize">Characteristics</span>
		</div>
	</div>

	<div class="row odd">
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Lot Size'"
				[dataPublicRecord]="publicRecord.lotSize" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Year Built'"
				[dataPublicRecord]="publicRecord.yearBuilt" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>
	</div>
	<div class="row">
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Building total'"
				[dataPublicRecord]="publicRecord.buildingAreaTotal" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Total finished'"
				[dataPublicRecord]="publicRecord.totalFinishedArea" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>
	</div>
	<div class="row odd">
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Below Grade Total'"
				[dataPublicRecord]="publicRecord.belowGradeTotal" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Below Grade Finished'"
				[dataPublicRecord]="publicRecord.belowGradeFinishedArea"
				(copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>
	</div>

	<div class="row ">
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Below Grade Unfinished'"
				[dataPublicRecord]="publicRecord.belowGradeUnfinishedArea"
				(copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Basement'"
				[dataPublicRecord]="publicRecord.basement" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>
	</div>

	<div class="row odd">
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Rooms'"
				[dataPublicRecord]="publicRecord.roomsTotal" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Bedrooms'"
				[dataPublicRecord]="publicRecord.bedroomsTotal" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>
	</div>

	<div class="row">
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Bathrooms'"
				[dataPublicRecord]="publicRecord.bathroomsTotal" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Stories'"
				[dataPublicRecord]="publicRecord.stories" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>
	</div>

	<div class="row odd">
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Fireplaces'"
				[dataPublicRecord]="publicRecord.fireplacesTotal" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Heating'"
				[dataPublicRecord]="publicRecord.heating" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>
	</div>

	<div class="row ">
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Garage spaces'"
				[dataPublicRecord]="publicRecord.garageSpaces" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Parking Features'"
				[dataPublicRecord]="publicRecord.parkingFeatures" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>
	</div>

	<div class="row odd">
		<div class="col-md-12 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Architectural Style'"
				[dataPublicRecord]="publicRecord.architecturalStyle"
				(copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>
	</div>

	<div class="divider transparent"></div>

	<div class="row">
		<div class="col separator">
			<span class="title text-capitalize">Owner Information</span>
		</div>
	</div>

	<div class="row odd">

		<div class="col-md-12 data-name-value">
			<div *ngFor="let ownerName of publicRecord.ownerNames; let i=index">
				<cv-ci-public-record-single-field [labelPublicRecord]="(i + 1) + ' Owner Name'"
					[dataPublicRecord]="ownerName.fullName" (copiedEvent)="copiedEvent($event)">
				</cv-ci-public-record-single-field>
			</div>
		</div>

	</div>

	<div class="row">
		<div class="col-md-12 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Mailing Address'"
				[dataPublicRecord]="publicRecord.mailUnparsedAddress"
				(copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>
	</div>

	<div class="row odd">

		<div class="col-md-12 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Mailing ZIP 4'"
				[dataPublicRecord]="publicRecord.mailPostalCodePlus4"
				(copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="divider  transparent"></div>

	<div class="row">
		<div class="col separator">
			<span class="title text-capitalize">Location Information</span>
		</div>
	</div>

	<div class="row odd">

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'ZIP'"
				[dataPublicRecord]="publicRecord.postalCode" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>

		</div>
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'ZIP 4'"
				[dataPublicRecord]="publicRecord.postalCodePlus4" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="row ">

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Subdivision'"
				[dataPublicRecord]="publicRecord.subdivisionName" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>

		</div>
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Zoning'"
				[dataPublicRecord]="publicRecord.zoningClassification"
				(copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="row odd">

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Census Tract'"
				[dataPublicRecord]="publicRecord.tract" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>

		</div>
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Map Reference'"
				[dataPublicRecord]="publicRecord.mapReference" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="row">

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Street Number'"
				[dataPublicRecord]="publicRecord.streetNumber" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>

		</div>
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Unit Number'"
				[dataPublicRecord]="publicRecord.unitNumber" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="row odd">

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Prefix'"
				[dataPublicRecord]="publicRecord.streetDirPrefix" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>

		</div>
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Street Name'"
				[dataPublicRecord]="publicRecord.streetName" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="row ">

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Suffix'"
				[dataPublicRecord]="publicRecord.streetDirSuffix" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>

		</div>
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'County'"
				[dataPublicRecord]="publicRecord.county" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="row odd">

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Unparsed Address'"
				[dataPublicRecord]="publicRecord.unparsedAddress" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>

		</div>
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'City'"
				[dataPublicRecord]="publicRecord.city" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="row ">

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'State'"
				[dataPublicRecord]="publicRecord.state" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>

		</div>
		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Lot Number'"
				[dataPublicRecord]="publicRecord.lotNumber" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="divider transparent"></div>

	<div class="row">
		<div class="col separator">
			<span class="title text-capitalize">Tax information</span>
		</div>
	</div>

	<div class="row odd">

		<div class="col-md-12 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Parcel Number'"
				[dataPublicRecord]="publicRecord.parcelNumber" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>

		</div>

	</div>

	<div class="row">

		<div class="col-md-12 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Legal Description'"
				[dataPublicRecord]="publicRecord.legaLDescription" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="divider transparent"></div>

	<div class="row">
		<div class="col separator">
			<span class="title text-capitalize">Assessment & Taxes</span>
		</div>
	</div>

	<div class="row odd">

		<div class="col-md-12 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Assessment Year'"
				[dataPublicRecord]="publicRecord.assessmentYear" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>

		</div>

	</div>

	<div class="row">

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Market Value Land'"
				[dataPublicRecord]="publicRecord.marketImprovementValue"
				(copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Market Value Improved'"
				[dataPublicRecord]="publicRecord.marketLandValue" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="row odd">

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Market Value Total'"
				[dataPublicRecord]="publicRecord.marketTotalValue" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Market Value Year'"
				[dataPublicRecord]="publicRecord.marketValueYear" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="row ">

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Assessed Value Land'"
				[dataPublicRecord]="publicRecord.assessmentLandValue"
				(copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Assessed Value Improved'"
				[dataPublicRecord]="publicRecord.assessmentImprovementValue"
				(copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="row odd">

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Tax Year'"
				[dataPublicRecord]="publicRecord.taxYear" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

		<div class="col-md-6 data-name-value">
			<cv-ci-public-record-single-field [labelPublicRecord]="'Total Tax'"
				[dataPublicRecord]="publicRecord.taxAmount" (copiedEvent)="copiedEvent($event)">
			</cv-ci-public-record-single-field>
		</div>

	</div>

	<div class="divider transparent"></div>

	<div class="row">
		<div class="col separator">
			<span class="title text-capitalize">Deeds</span>
		</div>
	</div>

	<div class="row">
		<div class="col p-0">
			<div class="deed-list">
				<div *ngFor="let deed of deeds; let i=index">
					<div (click)="deed.open = !deed.open"
						class="header-deed"
						[ngClass]="{'collapsed': i > 0}"
						data-bs-toggle="collapse"
						[attr.href]="'#multiCollapseExample'+i" role="button"
						[attr.aria-expanded]="i === 0 ? 'true' : 'false'"
						[attr.aria-controls]="'multiCollapseExample'+i">

						<span class="deed-date">
							<i class="fa" aria-hidden="true"
								[ngClass]="{
									'fa-angle-down': !deed.open,
									'fa-angle-up': deed.open
									}">
							</i>
							{{deed.recordingDate | date}}
						</span>
						<span class="deed-title">
							{{deed.title}}
						</span>
					</div>
					<div class="collapse"
						[attr.id]="'multiCollapseExample'+i"
						[ngClass]="{
							'show': i === 0
						}">

						<div class="">
							<div class="row odd">

								<div class="col-md-12 data-name-value">
									<cv-ci-public-record-single-field [labelPublicRecord]="'Deed type'"
										[dataPublicRecord]="deed.documentType" (copiedEvent)="copiedEvent($event)">
									</cv-ci-public-record-single-field>
								</div>

							</div>

							<div class="row">

								<div class="col-md-6 data-name-value">
									<cv-ci-public-record-single-field [labelPublicRecord]="'Code'"
										[dataPublicRecord]="deed.documentTypeCode"
										(copiedEvent)="copiedEvent($event)">
									</cv-ci-public-record-single-field>
								</div>

								<div class="col-md-6 data-name-value">
									<cv-ci-public-record-single-field [labelPublicRecord]="'Book Number'"
										[dataPublicRecord]="deed.bookNumber" (copiedEvent)="copiedEvent($event)">
									</cv-ci-public-record-single-field>
								</div>

							</div>

							<div class="row odd">

								<div class="col-md-6 data-name-value">
									<cv-ci-public-record-single-field [labelPublicRecord]="'Page Number'"
										[dataPublicRecord]="deed.pageNumber" (copiedEvent)="copiedEvent($event)">
									</cv-ci-public-record-single-field>
								</div>

								<div class="col-md-6 data-name-value">
									<cv-ci-public-record-single-field [labelPublicRecord]="'Document Number'"
										[dataPublicRecord]="deed.documentNumber1"
										(copiedEvent)="copiedEvent($event)">
									</cv-ci-public-record-single-field>
								</div>

							</div>

							<div class="row">

								<div class="col-md-6 data-name-value">
									<cv-ci-public-record-single-field [labelPublicRecord]="'Document Number 2'"
										[dataPublicRecord]="deed.documentNumber2"
										(copiedEvent)="copiedEvent($event)">
									</cv-ci-public-record-single-field>
								</div>

								<div class="col-md-6 data-name-value">
									<cv-ci-public-record-single-field [labelPublicRecord]="'Recording Date'"
										[dataPublicRecord]="deed.recordingDate | date"
										(copiedEvent)="copiedEvent($event)">
									</cv-ci-public-record-single-field>
								</div>

							</div>

							<div class="row odd">

								<div class="col-md-6 data-name-value">
									<cv-ci-public-record-single-field [labelPublicRecord]="'Sale Date'"
										[dataPublicRecord]="deed.saleDate | date"
										(copiedEvent)="copiedEvent($event)">
									</cv-ci-public-record-single-field>
								</div>

								<div class="col-md-6 data-name-value">
									<cv-ci-public-record-single-field [labelPublicRecord]="'Sale Price'"
										[dataPublicRecord]="deed.salePrice" (copiedEvent)="copiedEvent($event)">
									</cv-ci-public-record-single-field>
								</div>

							</div>

							<ng-container *ngIf="deed.title === 'MORTGAGE'">
								<div class="row">
									<div class="col-md-6 data-name-value">
										<cv-ci-public-record-single-field [labelPublicRecord]="'Lender'"
											[dataPublicRecord]="deed.lenderName"
											(copiedEvent)="copiedEvent($event)">
										</cv-ci-public-record-single-field>
									</div>

									<div class="col-md-6 data-name-value">
										<cv-ci-public-record-single-field [labelPublicRecord]="'Type'"
											[dataPublicRecord]="deed.lenderType"
											(copiedEvent)="copiedEvent($event)">
										</cv-ci-public-record-single-field>
									</div>
								</div>

								<div class="row odd">
									<div class="col-md-6 data-name-value">
										<cv-ci-public-record-single-field [labelPublicRecord]="'Amount'"
											[dataPublicRecord]="deed.mortgageAmount"
											(copiedEvent)="copiedEvent($event)">
										</cv-ci-public-record-single-field>
									</div>

									<div class="col-md-6 data-name-value">
										<cv-ci-public-record-single-field [labelPublicRecord]="'Type'"
											[dataPublicRecord]="deed.mortgageType"
											(copiedEvent)="copiedEvent($event)">
										</cv-ci-public-record-single-field>
									</div>
								</div>
							</ng-container>


							<div *ngIf="deed?.borrowers?.length > 0 ">
								<div class="divider"></div>
								<span class="title">
									Borrowers
								</span>

								<div class="row" *ngFor="let borrower of deed.borrowers; let br=index"
									[ngClass]="{'odd': br % 2 === 0}">

									<div class="col-md-6 data-name-value">
										<cv-ci-public-record-single-field
											[labelPublicRecord]="(br+1) + ' Borrower name'"
											[dataPublicRecord]="borrower.fullName"
											(copiedEvent)="copiedEvent($event)">
										</cv-ci-public-record-single-field>
									</div>

									<div class="col-md-6 data-name-value">
										<cv-ci-public-record-single-field
											[labelPublicRecord]="(br+1) + ' Borrower type'"
											[dataPublicRecord]="borrower.borrowerType"
											(copiedEvent)="copiedEvent($event)">
										</cv-ci-public-record-single-field>
									</div>

								</div>
							</div>

							<div *ngIf="deed?.buyers?.length > 0 ">
								<div class="divider"></div>
								<span class="title">
									Buyers
								</span>

								<div class="row" *ngFor="let buyer of deed.buyers; let b=index"
									[ngClass]="{'odd': b % 2 === 0}">

									<div class="col-md-6 data-name-value">
										<cv-ci-public-record-single-field [labelPublicRecord]="(b+1) + ' Buyer name'"
											[dataPublicRecord]="buyer.fullName" (copiedEvent)="copiedEvent($event)">
										</cv-ci-public-record-single-field>
									</div>

									<div class="col-md-6 data-name-value">
										<cv-ci-public-record-single-field [labelPublicRecord]="(b+1) + ' Buyer type'"
											[dataPublicRecord]="buyer.buyerType"
											(copiedEvent)="copiedEvent($event)">
										</cv-ci-public-record-single-field>
									</div>
								</div>
							</div>

							<div *ngIf="deed?.sellers?.length > 0 ">
								<div class="divider"></div>
								<span class="title">
									Sellers
								</span>

								<div class="row" *ngFor="let seller of deed.sellers; let s=index"
									[ngClass]="{'odd': s % 2 === 0}">

									<div class="col-md-12 data-name-value">
										<cv-ci-public-record-single-field [labelPublicRecord]="(s+1) + ' Seller name'"
											[dataPublicRecord]="seller.fullName"
											(copiedEvent)="copiedEvent($event)">
										</cv-ci-public-record-single-field>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</div>
